import { render, staticRenderFns } from "./PaymentMethodSpan.vue?vue&type=template&id=5edde1ab&"
import script from "./PaymentMethodSpan.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodSpan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports